export default "__VITE_PUBLIC_ASSET__1d788315__"